import React from 'react';

import FormPwdResetMail from '../forms/FormPwdResetMail.jsx';

import meta from '../../config/meta';

const PagePwdResetMail = () => {
  meta.set({ title: '傳送重設密碼電郵' });

  return (
    <div className="container py-4">
      <div className="row justify-content-center">
        <div className="col-md-5">
          <FormPwdResetMail />
        </div>
      </div>
    </div>
  );
};

export default PagePwdResetMail;
